import url from 'url'

export function cleanFirebaseObject (obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null || obj[key] === undefined) delete obj[key]
  })
  delete obj._client
  return obj
}

export function getColorMap (color) {
  if (!color) color = 'blueberry'
  let colors = {
    tomato: '#d67b8c',
    tangerine: '#f1522c',
    banana: '#f4be3b',
    basil: '#177f45',
    sage: '#deefe6',
    peacock: '#bde6e6',
    blueberry: '#9c9cce',
    lavender: '#7a87c9',
    grape: '#8d2ca7',
    salmon: '#e47c75',
    charcoal: '#616161',
    white: '#f6f5f4'
  }
  return colors[color]
}

export function getPreheatTemperature (steps) {
  if (!steps) return
  steps = steps.join(' ').split('.')
  for (var i = 0; i < steps.length; i++) {
    let match = steps[i].match(/[pre-]*heat[A-Za-z\s]+oven+[A-Za-z\s]+(\d+)?[\sº°degrees]*\s?([CF])?/i)
    if (match) {
      let value = parseInt(match[1])
      if (Number.isInteger(value)) {
        let temp = {
          value,
          units: match[2] || ''
        }
        return `${temp.value}&deg;${temp.units}`
      }
    }
  }
  return null
}

export function getDomain (uri) {
  if (!uri) return

  let resolvedUrl = url.resolve('https://cookmark.io', uri)
  let parsedUrl = url.parse(resolvedUrl)
  if (!parsedUrl.hostname) return
  return parsedUrl.hostname.replace('www.', '')
}

export function getWindowSizeName () {
  const width = window.innerWidth
  if (width <= 480) {
    return 'xsmall'
  } else if (width <= 1024) {
    return 'small'
  } else if (width <= 1280) {
    return 'medium'
  } else if (width <= 1600) {
    return 'large'
  } else {
    return 'xlarge'
  }
}

export function getBrowserMode () {
  var isStandalone = !!navigator.standalone
  var isSafari = !!navigator.userAgent.match(/safari/i)
  var isIOS = !!navigator.platform.match(/iPhone|iPod|iPad/)

  if (isIOS) {
    if (!isStandalone && isSafari) {
      return 'browser'
    } else if (isStandalone && isSafari) {
      return 'standalone'
    } else if (!isStandalone && !isSafari) {
      return 'webview'
    }
  } else {
    return 'browser'
  }
}

export function getScreenOrientation () {
  return window.innerWidth >= window.innerHeight
    ? 'landscape'
    : 'portrait'
}

const urlRegex = /(https?:\/\/[^\s]+)/g
export function getUrlFromText (text) {
  try {
    const matches = (text).match(urlRegex)
    return matches[0] || null
  } catch (err) {
    return null
  }
}

export function ensureProtocol (url) {
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url
  }
  return url
}

export function errorMessages () {
  return {
    collection: {
      name: {
        required: 'A collection name is required.',
        unique: 'Collection name already exists.'
      }
    },
    feedback: {
      comment: {
        required: 'A comment is required.'
      }
    },
    recipe: {
      name: {
        required: 'A recipe name is required.'
      }
    },
    url: {
      required: 'A URL is required.',
      format: 'Doesn\'t look like a valid URL.'
    }
  }
}

export function splitListByProperty (list, property) {
  // if (!list) return {}
  var sectionedList = {}
  var currentSection
  // Empty values can creep in to the firebase object when the key index
  //    is not sequential, ie 0, 1, 2, 4. Compact the list to remove null values
  //
  var compactList = list.filter(el => {
    return el !== null
  })
  for (var i = 0; i < compactList.length; i++) {
    if (i === 0 && !compactList[i][property]) {
      currentSection = []
      sectionedList.none = currentSection
    } else if (compactList[i][property]) {
      currentSection = []
      sectionedList[compactList[i].text] = currentSection
      continue
    }
    currentSection.push(compactList[i])
  }
  return sectionedList
}

export function sortObjectByProperty (object, property) {
  return Object.values(object).sort((a, b) => a[property] - b[property])
}

export function splitObjectByProperty (object, property) {
  let list = []
  let section = { items: [] }
  let items = sortObjectByProperty(object, 'priority')

  items.forEach(item => {
    if (item.section && item.priority === 0) {
      section.title = item.text
    } else if (item.section && item.priority > 0) {
      list.push(section)
      section = { title: item.text, items: [] }
    } else {
      section.items.push(item)
    }
  })
  list.push(section)
  return list
}

/**
 * In case of no match
 */
const NO_MATCH = 'unknown'

/**
 * Browser strings
 */
const Browser = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Safari: 'Safari',
  IE: 'IE',
  Opera: 'Opera',
  UCBrowser: 'UCBrowser',
  Edge: 'Edge',
  Xiaomi: 'Xiaomi'
}

/**
 * @param {string} ua      - Browser userAgent
 * @param {string} browser - Browser string
 */
function getDevice (ua, browser) {
  let device = NO_MATCH
  const temp = ua.split(')')[0].split('(')[1].split(';')

  switch (browser) {
    case Browser.Chrome:
      if (temp.length === 2) {
        device = temp[1]
      } else {
        device = temp[2]
      }
      break
    case Browser.Safari:
    case Browser.IE:
    case Browser.Firefox:
    case Browser.Edge:
      device = temp[0]
      break
    case Browser.UCBrowser:
      device = temp[4]
      break
    case Browser.Xiaomi:
      device = temp[4]
      break
    default:
      device = NO_MATCH
  }

  return device
}

/**
 * @param {string} ua - Browser userAgent
 */
function getOS (ua) {
  let os = NO_MATCH
  const _ua = ua.toLowerCase()
  if (_ua.indexOf('win') !== -1) {
    os = 'Windows'
  } else if (_ua.indexOf('mac') !== -1) {
    os = 'MacOS'
  } else if (_ua.indexOf('x11') !== -1) {
    os = 'UNIX'
  } else if (_ua.indexOf('linux') !== -1) {
    os = 'Linux'
  } else if (_ua.indexOf('android') !== -1) {
    os = 'Android'
  } else if (_ua.indexOf('webos') !== -1) {
    os = 'webOS'
  } else if (_ua.indexOf('iphone') !== -1) {
    os = 'iOS'
  } else if (_ua.indexOf('ipad') !== -1) {
    os = 'iOS'
  } else if (_ua.indexOf('ipod') !== -1) {
    os = 'iOS'
  } else if (_ua.indexOf('blackberry') !== -1) {
    os = 'BlackBerry'
  } else if (_ua.indexOf('windows phone') !== -1) {
    os = 'Windows Phone'
  }
  return os
}

/**
 * @param {string} ua - Browser userAgent
 */
function getBrowser (ua) {
  let browser = NO_MATCH
  const _ua = ua.toLowerCase()
  if ((_ua.indexOf('opera') || _ua.indexOf('opr')) !== -1) {
    browser = Browser.Opera
  } else if (_ua.indexOf('xiaomi') !== -1) {
    browser = Browser.Xiaomi
  } else if (_ua.indexOf('ucbrowser') !== -1) {
    browser = Browser.UCBrowser
  } else if (_ua.indexOf('chrome') !== -1) {
    browser = Browser.Chrome
  } else if (_ua.indexOf('safari') !== -1 || _ua.indexOf('iphone') || _ua.indexOf('ipad')) {
    browser = Browser.Safari
  } else if (_ua.indexOf('firefox') !== -1) {
    browser = Browser.Firefox
  } else if ((_ua.indexOf('msie') !== -1) || document.documentMode) {
    browser = Browser.IE
  } else if (!window.styleMedia) {
    browser = Browser.Edge
  }
  return browser
}

/**
 * Returns an object containing the os, browser and device names
 * @return {{os: string, browser: string, device: string}}
 */
export function getBrowserDetails () {
  const userAgent = window.navigator.userAgent

  const os = getOS(userAgent)
  const browser = getBrowser(userAgent)
  const device = getDevice(userAgent, browser)

  return {
    os,
    browser,
    device,
    userAgent
  }
}

export function getImage (url) {
  return new Promise((resolve, reject) => {
    var image = new Image()
    image.onload = () => {
      resolve(image)
    }
    image.onerror = () => {
      reject(new Error())
    }
    image.src = url
  })
}



// WEBPACK FOOTER //
// ./src/utils/index.js